import { assetRecordBookingAvailability, withAssetBookingAvailability } from '../utils/assetBookability';
import { useI18n } from '../i18n';
import styles from './AssetBookingAvailabilitySection.module.css';

type AssetBookingAvailabilitySectionProps = {
  assetBody: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
  disabled?: boolean;
  id?: string;
};

export function AssetBookingAvailabilitySection({
  assetBody,
  onChange,
  disabled = false,
  id = 'asset-booking-availability',
}: AssetBookingAvailabilitySectionProps) {
  const { t } = useI18n();
  const available = assetRecordBookingAvailability(assetBody);

  return (
    <fieldset className={styles.fieldset} aria-labelledby={`${id}-legend`}>
      <legend id={`${id}-legend`} className={styles.legend}>
        {t('assets.bookingAvailabilityLegend')}
      </legend>
      <label className={styles.row}>
        <input
          id={id}
          type="checkbox"
          className={styles.checkbox}
          checked={available}
          disabled={disabled}
          onChange={(event) => {
            onChange(withAssetBookingAvailability(assetBody, event.target.checked));
          }}
        />
        <span className={styles.title}>{t('assets.availableForBooking')}</span>
      </label>
    </fieldset>
  );
}
